import { mesh2ndRect } from "./mesh2ndRect";
import { mesh3rdRect } from "./mesh3rdRect";
import { mesh4thRect } from "./mesh4thRect";

// ===== CSV =====
const fetchCombinedCsv = async (urls) => {
  const texts = await Promise.all(
    urls.map(async (url) => {
      const r = await fetch(url);
      if (!r.ok) throw new Error(`HTTP ${r.status} ${url}`);
      return await r.text();
    })
  );
  return texts.join("");
};

const parseCsvTo2D = (csvText) => {
  const rows = csvText.split("\r\n");
  return rows.map((line) => line.split(","));
};

const pickStyle = (metadata, ratio1set, alpha1set, color1set, shikii1set, isKokudo) => {
  const shikii1 = Number(shikii1set?.[0] ?? (isKokudo ? metadata.kokudo_shikii1 : metadata.shikii1) ?? 0);
  const shikii2 = Number(shikii1set?.[1] ?? (isKokudo ? metadata.kokudo_shikii2 : metadata.shikii2) ?? 0);
  const shikii3 = Number(shikii1set?.[2] ?? (isKokudo ? metadata.kokudo_shikii3 : metadata.shikii3) ?? 0);
  const shikii4 = Number(shikii1set?.[3] ?? (isKokudo ? metadata.kokudo_shikii4 : metadata.shikii4) ?? 0);

  const hanrei1_color = (color1set?.[0] ?? metadata.hanrei1_color) || "";
  const hanrei2_color = (color1set?.[1] ?? metadata.hanrei2_color) || "";
  const hanrei3_color = (color1set?.[2] ?? metadata.hanrei3_color) || "";
  const hanrei4_color = (color1set?.[3] ?? metadata.hanrei4_color) || "";
  const hanrei5_color = (color1set?.[4] ?? metadata.hanrei5_color) || "";

  return {
    shikii1, shikii2, shikii3, shikii4,
    hanrei1_color, hanrei2_color, hanrei3_color, hanrei4_color, hanrei5_color,
    ratio: Number(ratio1set),
    alpha: Number(alpha1set),
  };
};

// ★ slot方式を廃止：parent（dataname）配下の子だけ消す
const clearChildrenByParent = (viewer, parent) => {
  if (!viewer || !parent) return;
  const list = viewer.entities.values.slice(); // 走査中にremoveするのでコピー
  for (const ent of list) {
    if (!ent) continue;
    if (ent === parent) continue;
    // Cesium Entity の parent は Entity / EntityCollection として参照できる
    if (ent.parent === parent) {
      try { viewer.entities.remove(ent); } catch {
        //
      }
    }
  }
};

export const csvfecth = (
  rfcs,
  dataname,
  no,
  year,
  area,
  csv_name,
  year1_nihonsokuchi,
  metadata,
  ratio1set,
  alpha1set,
  color1set,
  shikii1set,
  checkflag
) => {
  const viewer = rfcs?.current?.cesiumElement;
  if (!viewer || !dataname || !metadata) return;

  // ★ここが旧来思想：parent配下だけ掃除（slot方式は使わない）
  clearChildrenByParent(viewer, dataname);

  const areaarr = area.includes("&") ? area.split("&") : [area];
  const urls = areaarr.map((areai) => `/csv/${metadata.no}/${areai}_${csv_name}_${year}.csv`);

  fetchCombinedCsv(urls)
    .then((csvText) => parseCsvTo2D(csvText))
    .then((meshdata) => {
      if (!meshdata?.[0]?.[0] || String(meshdata[0][0]).startsWith("<")) return;

      const code = String(meshdata[0][0]);
      const codeLen = code.length;

      // 空行除去
      const rows = meshdata.filter((r) => Array.isArray(r) && r.length > 1 && r[0]);

      if (codeLen === 6) {
        const min = Number(metadata.kokudo_min);
        const style = pickStyle(metadata, ratio1set, alpha1set, color1set, shikii1set, true);

        for (let i = 0; i < rows.length; i++) {
          if (Number(rows[i][1]) > min) {
            const child = mesh2ndRect(
              rows[i][0], rows[i][1], rows[i][2],
              dataname, undefined,
              style.shikii1, style.shikii2, style.shikii3, style.shikii4,
              style.hanrei1_color, style.hanrei2_color, style.hanrei3_color, style.hanrei4_color, style.hanrei5_color,
              style.ratio, style.alpha,
              metadata.kokudo_ratio,
              year1_nihonsokuchi
            );
            viewer.entities.add(child); // ★parentはmesh側が付ける契約
          }
        }
        return;
      }

      if (codeLen === 8) {
        const min = Number(metadata.min);
        const style = pickStyle(metadata, ratio1set, alpha1set, color1set, shikii1set, false);

        let hit = 0;
        rows.forEach((data) => {
          if (Number(data[1]) > min) {
            const child = mesh3rdRect(
              data[0], data[1], data[2],
              dataname, undefined,
              style.shikii1, style.shikii2, style.shikii3, style.shikii4,
              style.hanrei1_color, style.hanrei2_color, style.hanrei3_color, style.hanrei4_color, style.hanrei5_color,
              style.ratio, style.alpha,
              metadata.ratio,
              year1_nihonsokuchi
            );
            viewer.entities.add(child);
            hit++;
          }
        });

        if (!hit) setTimeout(() => window.alert("この地域には閾値以上のデータがありません。"), 3000);
        return;
      }

      if (codeLen === 9) {
        const min = Number(metadata.min);
        const style = pickStyle(metadata, ratio1set, alpha1set, color1set, shikii1set, false);

        for (let i = 0; i < rows.length; i++) {
          if (Number(rows[i][1]) > min) {
            const child = mesh4thRect(
              rows[i][0], rows[i][1], rows[i][2],
              dataname, undefined,
              style.shikii1, style.shikii2, style.shikii3, style.shikii4,
              style.hanrei1_color, style.hanrei2_color, style.hanrei3_color, style.hanrei4_color, style.hanrei5_color,
              style.ratio, style.alpha,
              metadata.ratio,
              year1_nihonsokuchi
            );
            viewer.entities.add(child);
          }
        }
      }
    })
    .catch((e) => {
      console.warn("[csvfecth] fetch failed", e, { year, area, csv_name, urls });
    });
};